import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import { LogoMark } from "@/components/Logo";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import NewClient from "@/pages/NewClient";
import ClientDetail from "@/pages/ClientDetail";
import CalendarPage from "@/pages/CalendarPage";
import Operators from "@/pages/Operators";
import Treatments from "@/pages/Treatments";
import Inventory from "@/pages/Inventory";
import Quotes from "@/pages/Quotes";
import QuoteEditor from "@/pages/QuoteEditor";
import QuotePrint from "@/pages/QuotePrint";
import Loyalty from "@/pages/Loyalty";
import OrderPrint from "@/pages/OrderPrint";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#FDFBF7]"><div className="animate-pulse"><LogoMark size={72} /></div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/magazzino/ordini/:id/stampa" element={<Protected><OrderPrint /></Protected>} />
          <Route path="/preventivi/:id/stampa" element={<Protected><QuotePrint /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="clienti" element={<Clients />} />
            <Route path="clienti/nuovo" element={<NewClient />} />
            <Route path="clienti/:id" element={<ClientDetail />} />
            <Route path="calendario" element={<CalendarPage />} />
            <Route path="operatori" element={<Operators />} />
            <Route path="trattamenti" element={<Treatments />} />
            <Route path="magazzino" element={<Inventory />} />
            <Route path="preventivi" element={<Quotes />} />
            <Route path="preventivi/nuovo" element={<QuoteEditor />} />
            <Route path="preventivi/:id" element={<QuoteEditor />} />
            <Route path="fedelta" element={<Loyalty />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#FDFBF7", border: "1px solid #E8E1D7", color: "#24211E" } }} />
    </AuthProvider>
  );
}

export default App;
